import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserFacade } from '@app/core/facades/user.facade';
import { DataHelper } from '@hal/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserGuard {
  constructor(
    private _router: Router,
    private _userFacade: UserFacade
  ) {}

  // check if user has permissions to view the page
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // get permissions from route data
    const permissions: any[] = route?.data['permissions'] || [];
    // if user has permissions to view the page
    if (!DataHelper.hasAnyElement(permissions) || this._userFacade.canUserDoAction(permissions)) {
      return true;
    }
    return this._router.parseUrl('403');
  }
}
